import { Component, Input } from '@angular/core';
import { IFeedbackResponseDetails } from '../../models/application-details.model';

@Component({
  standalone: false,
  selector: 'irembogov-application-feedback',
  templateUrl: './application-feedback.component.html',
  styleUrls: ['./application-feedback.component.scss'],
})
export class ApplicationFeedbackComponent {
  @Input() applicationFeedBack: IFeedbackResponseDetails[] = [];
}
